import React from 'react';
import { AddressSearchContainer } from '../styles';
import { reduxForm } from 'redux-form';
import { NewAddressSearch } from '@Components';

type AddressSearchFormProps = {
  retrievedValuesCallBack: (data: any) => any;
  searchPlaceHolder: string;
  isBeneAddressFlow?: boolean;
};
const AddressSearchForm: React.FC<AddressSearchFormProps> = ({
  retrievedValuesCallBack,
  searchPlaceHolder,
  isBeneAddressFlow
}: AddressSearchFormProps) => {
  const handleRetrievedValuesCallBack = (values: any) => retrievedValuesCallBack(values);
  return (
    //@ts-ignore
    <AddressSearchContainer>
      <NewAddressSearch
        newSearchUi={true}
        iconPlacement="left"
        retrievedValuesCallBack={handleRetrievedValuesCallBack}
        searchPlaceHolder={searchPlaceHolder}
        isNewBeneAddressFlow={isBeneAddressFlow}
      />
    </AddressSearchContainer>
  );
};

const AddressSearch = reduxForm<AddressSearchFormProps, any>({
  form: 'auAddressSearchForm'
})(AddressSearchForm);

export default AddressSearch;
